import TrackPage from "./TrackPage";

export default function TrackShipment() {
  return <TrackPage embedded />;
}
